export default __webpack_public_path__ + "static/media/lamp-orange-full.074a99ae.svg";